/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { useState } from 'react';
import { useCallback } from 'react';
import { getRoleHistory } from '../../../../../../store/reducers/role/roleAction';

const RoleHistory = ({ selectedRole }) => {
    const [historyList, setHistoryList] = useState([]);
    const dispatch = useDispatch()
    const roleHistory = useSelector(state => state.role.roleHistory)
    const fetchRoleHistory = useCallback(async () => {
        dispatch(getRoleHistory({ "roleID": selectedRole.roleID }));

    }, [dispatch, selectedRole]);
    useEffect(() => {
        fetchRoleHistory()
    }, [fetchRoleHistory]);
    useEffect(() => {
        setHistoryList([]);
        if (roleHistory?.length > 0) {
            roleHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record.roleName, details: element.Record.roleDetails,
                        createdBy: element.Record.createdBy ?? "",
                        updatedBy: element.Record.updatedBy ?? "",
                    }
                }]);
            });
        }
    }, [roleHistory]);

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Role  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default RoleHistory;